<template>
  <div>
    <div
      id="echart_id"
      ref="chart"
      :class="'js_export_report_dymanic_chart'"
      :style="showStub ? {pointerEvents: 'none'} : null"
    />
    <div
      :class="[$.legend, 'export_html_legend']"
      :style="{width: width, left: leftPos}"
    >
      <div
        v-for="(item, index) in legendItems"
        :key="index"
        :class="[
          $.wrapper,
          'export_html_legend_item',
          disabledSeries[item.name] && 'disabled'
        ]"
        @click="toggleSelect(item.name)"
      >
        <div
          :class="[$.box, 'export_html_box']"
          :style="{background: item.color}"
        />
        <div :class="[$.name, 'export_html_name']">
          {{ item.label }}
        </div>
      </div>
    </div>
    <div
      v-if="showStub && showStubMessage"
      :class="$.stub_description"
      :style="{width: width, left: leftPos}"
    >
      <div :class="$.wrapper">
        <span :class="$.text">
          {{ locales(`report_page_no_filtered_data`) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from '../../../libs/echarts';

export default {
  props: {
    isStatic: { type: Boolean, required: true, default: false },
    config: { type: Object, required: true, default: () => {} },
    stubConfig: { type: Object, required: true, default: () => {} },
    customLegends: { type: Boolean, required: false, default: false },
    showStubMessage: { type: Boolean, required: false, default: true },
  },
  data() {
    return {
      id: 'chart',
      locales: __,
      instance: null,
      width: '100%',
      leftPos: 0,
      legendItems: [],
      disabledSeries: {},
      timeout: null,
      localConfig: null,
    };
  },
  computed: {
    leftSidebarWidth() {
      return this.$store.getters.leftSidebarWidth;
    },
    allLegendItemsDisabled() {
      return this.legendItems.every(item => this.disabledSeries[item.name]);
    },
    showStub() {
      return this.isStatic || this.allLegendItemsDisabled;
    },
  },
  watch: {
    config: {
      handler(conf) {
        if (conf) {
          setTimeout(() => {
            this.localConfig = this.modifiedConfig(conf);
            this.instance.setOption(this.localConfig);
            this.setLegendItems();
          }, 0);
        }
      },
      immediate: true,
    },
    isStatic: {
      handler(flag) {
        if (!this.instance) {
          return;
        }

        setTimeout(() => this.onResize(flag), 0);
      },
      immediate: true,
    },
    leftSidebarWidth() {
      this.onResize();
    },
  },
  mounted() {
    this.instance = echarts.init(this.$refs.chart);
    this.instance.setOption(this.modifiedConfig(this.config));
    this.setLegendItems();
    this.onResize();

    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    echarts.dispose(this.instance);
  },
  methods: {
    setLegendItems() {
      if (this.customLegends) {
        const currentConfig = this.isStatic ? this.stubConfig : this.config;
        const series = currentConfig.series;

        if (!series) return;

        this.legendItems = currentConfig.series.map((item, index) => {
          const seriesData = series.find(i => i.name === item.name);
          let color = seriesData.color;

          if (item.name in this.disabledSeries && seriesData.disabledColor) {
            color = seriesData.disabledColor;
          }

          return {
            name: item.name,
            label: this.isStatic ? '-' : __(`${item.label.text()}`),
            color,
          };
        });
      }
    },
    onResize() {
      const width = document.documentElement.clientWidth - this.leftSidebarWidth;
      const height = document.documentElement.clientHeight - 220;

      this.instance.resize({ width, height });
      this.width = `${width}px`;
      this.leftPos = `${this.leftSidebarWidth}px`;
    },
    toggleSelect(name) {
      if (this.isStatic) {
        return;
      }

      const activeSeriesCountBefore = this.legendItems.filter(item => !this.disabledSeries[item.name]).length;

      if (name in this.disabledSeries) {
        delete this.disabledSeries[name];
      } else {
        this.disabledSeries[name] = true;
      }

      this.setLegendItems();

      this.$nextTick(() => {
        const activeSeriesCountAfter = this.legendItems.filter(item => !this.disabledSeries[item.name]).length;

        if (!activeSeriesCountAfter) {
          const updatedConfig = { ...this.stubConfig };

          updatedConfig.legend.selected = this.legendItems.reduce((acc, item) => {
            acc[item.name] = true;

            return acc;
          }, {});
          this.instance.setOption(updatedConfig);
        } else if (!activeSeriesCountBefore) {
          const updatedConfig = { ...this.localConfig };

          updatedConfig.legend.selected = this.legendItems.reduce((acc, item) => {
            acc[item.name] = !this.disabledSeries[item.name];

            return acc;
          }, {});
          this.instance.setOption(updatedConfig);
        } else {
          this.instance.dispatchAction({
            type: 'legendToggleSelect',
            name,
          });
        }
      });

      // this.instance.dispatchAction({
      //   type: 'legendToggleSelect',
      //   name,
      // });

      // if (name in this.disabledSeries) {
      //   delete this.disabledSeries[name];
      // } else {
      //   this.disabledSeries[name] = true;
      // }

      // this.setLegendItems();
      // this.checkEnabled();
    },
    modifiedConfig(config) {
      const hasConfig = config && Object.keys(config).length;
      const currentConfig = hasConfig ? config : this.stubConfig;
      const modified = { ...currentConfig };
      const chartWidth = this.$refs.chart.clientWidth * 0.8;
      const width = Math.floor(chartWidth / (modified.xAxis.data.length || 1));

      modified.xAxis.axisLabel.width = width - 10;

      if (modified.xAxis.data.length > 15) {
        modified.xAxis.axisLabel.show = false;
      }

      return modified;
    },
  },
};
</script>
<style module="$" lang="less">
@import '../../../less/_mixins.less';
@import '../../../less/_fonts.less';
.stub_description {
  display: flex;
  justify-content: center;
  position: fixed;
  top: 50%;
  transform: translateY(-50%);

  .wrapper {
    background: #fff;
    padding: 10px;

    .text {
      margin: 0 auto;
      .FontLatoRegular;
      font-size: 18px;
      text-align: center;
      opacity: .5;
    }
  }
}

.legend {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 52px;

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .icon {
      display: flex;
      align-items: center;
    }

    .box {
      width: 35px;
      height: 20px;
      border-radius: 2px;
    }

    .name {
      .FontLatoRegular;
      font-size: 16px;
      color: #191919;
      padding-left: 8px;
    }

    &:not(:last-child) {
      margin-right: 24px;
    }
  }
}
</style>
